var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35135 3.88244H2.67568C1.75023 3.88244 1 4.63267 1 5.55812V10.5851C1 12.436 2.50045 13.9365 4.35135 13.9365H7.07432M4.35135 3.88244V0.950012M4.35135 3.88244H9.7973M7.07432 13.9365H9.7973C11.6482 13.9365 13.1486 12.436 13.1486 10.5851V5.55812C13.1486 4.63267 12.3984 3.88244 11.473 3.88244H9.7973M7.07432 13.9365V16.45M9.7973 3.88244V0.950012",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.60eb90494552bc8a7a9de2487eb161e8.svg";
export { ForwardRef as ReactComponent };